<template>
    <div class="block-editor reservation-select-day">
        <div class="reservation-select-day-wrapper">
            <div class="inputTitle">{{ $t("chatbotv2.RESERVATION_SELECT_DAY") }}</div>
            <div class="text-editor-wrapper">
                <a-select show-search v-model="clone.reservationPlanId" style="width: 100%">
                    <a-select-option
                        v-for="(reservationPlan, index) of reservationPlans"
                        :key="index"
                        :value="reservationPlan._id"
                    >
                        {{ reservationPlan.title }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="inputTitle mt-5 mb-2 font-weight-bold">{{ $t("chatbotv2.followingAttributesFilled") }}</div>
        <section class="next-step-filled-items-wrapper">
            <div class="logos middle-section" v-for="attr in nextStepFilledValue" :key="attr">
                <AttributeIconPreview :attribute="attr" />
                <span class="ml-2">
                    <AttributeLabel :attribute="attr" />
                </span>
            </div>
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";

import _ from "lodash";
import { CALENDAR_API } from "../../../../../../../api/calendar";
import { mapState } from "vuex";

const log = log2("ReservationSelectDay");
export default {
    name: "ReservationSelectDay",
    components: { TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: ["reservation_day"],
            reservationPlans: [],
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    mounted() {
        log("mounted");
        CALENDAR_API.getAllReservationList().then((res) => {
            this.reservationPlans = res;
        });
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.reservation-select-day {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: rgba(208, 41, 46, 0.32);
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #ffdc66;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .reservation-select-day-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>
